import Vue from 'vue'
const url = window.$website.url
const request = Vue.prototype.$axios;
// const baseUrl = url + '/visual-global'
const baseUrl = '/dtv/api/next/dashboard'
export const getList = (params) => request({
  url: baseUrl + "/global/get/page/by/condition",
  method: 'get',
  params: { cmd: params }
});

export const getObj = (id) => request({
  url: baseUrl + '/detail',
  method: 'get',
  params: {
    id
  }
});

export const addObj = (data) => request({
  url: baseUrl + '/global/do/create',
  method: 'post',
  data: data
});
export const updateObj = (data) => request({
  url: baseUrl + '/global/do/update',
  method: 'put',
  data: data
});



export const delObj = (id) => request({
  url: baseUrl + '/global/do/delete/by/id',
  method: 'delete',
  data: [id]
});
